import { useQuery } from '@tanstack/react-query';
import { fetchDashboardData } from '../services/dashboardService';

export const useDashboardData = (environment: 'staging' | 'prod' = 'staging') => {
  return useQuery({
    queryKey: ['dashboard', environment],
    queryFn: () => fetchDashboardData(environment),
    staleTime: 5 * 60 * 1000, // 5 minutes
    // refetchOnMount: 'always', // Always fetch fresh data when component mounts
  });
};
